export const baseUrl = process.env.NEXT_PUBLIC_DOMAIN;
export const apiUrl = String(process.env.NEXT_PUBLIC_API_BASE_URL);

export const apiTranslationsUrl = String(process.env.NEXT_PUBLIC_API_TRANSLATIONS_BASE_URL);
export const localUrl = process.env.NEXT_PUBLIC_LOCAL_DOMAIN;
export const orderFormUrl = process.env.NEXT_PUBLIC_API_CUSTOMER_URL;

export const isStage = !!baseUrl?.match(/devstage.cloud/);

export const WRITING_SERVICE_SUBDOMAIN = "writing";

export const SITE_NAME = "StudyBounty.com";

export const SITE_DOMAIN = SITE_NAME.toLowerCase();

export const SUPPORT_EMAIL = "support@studybounty.com";

export const paperFormats = [
  {
    id: 1,
    name: "MLA",
  },
  {
    id: 2,
    name: "APA",
  },
  {
    id: 3,
    name: "Chicago",
  },
  {
    id: 4,
    name: "Harvard",
  },
  {
    id: 5,
    name: "Other",
  },
];

export const paperTypes = [
  {
    id: 1,
    name: "Essay",
  },
  {
    id: 2,
    name: "Coursework",
  },
  {
    id: 3,
    name: "Term Paper",
  },
  {
    id: 4,
    name: "Research Paper",
  },
  {
    id: 5,
    name: "Book Report",
  },
  {
    id: 6,
    name: "Movie Review",
  },
  {
    id: 7,
    name: "Case Study",
  },
  {
    id: 8,
    name: "Annotated Bibliography",
  },
  {
    id: 9,
    name: "Article",
  },
  {
    id: 10,
    name: "Assignment",
  },
];

export const academicLevels = [
  {
    id: 1,
    name: "High School",
  },
  {
    id: 2,
    name: "College",
  },
  {
    id: 3,
    name: "University",
  },
  {
    id: 4,
    name: "Master’s",
  },
  {
    id: 5,
    name: "Ph.D.",
  },
];

export const typeOfWorks = [
  {
    id: 1,
    name: "Writing from scratch",
  },
  {
    id: 2,
    name: "Editing",
  },
  {
    id: 3,
    name: "Presentation",
  },
  {
    id: 4,
    name: "Review",
  },
];

export const CHATWOOT_TOKEN = "CKFinWPLmxK1ikxuPA9dc23L"; // https://chat.cloudsend.pro/app/accounts/2/settings/inboxes/15
export const TOOLS_LASTMOD_DATE = "2021-12-23T00:00:01.000Z";
export const SERVICE_LASTMOD_DATE = "2021-12-29T00:00:00.000Z";

export const LEGAL_LASTMOD_DATE = "2025-07-09T00:00:00.000Z";

export const LEGAL_LASTMOD_DATE_NEW = "2025-07-09T00:00:00.000Z";

export const PHONE_TEXT = "+1 (585) 438 02 31";

export const PHONE_LINK = "tel:+15854380231";

export const GA_CODE = process.env.NEXT_PUBLIC_GA_CODE; // Google Analytics code (MEASUREMENT ID)

export const MAIN_SITE_SERVICE_PAGES = [
  {
    url: "",
    // changefreq: 'daily',
    lastmod: "2023-05-01T00:00:00.000Z",
    priority: "1.0",
    name: "Home",
  },
  {
    url: "/about-us",
    name: "About us",
  },
  {
    url: "/essay-types",
    name: "Essay type",
  },
  {
    url: "/faq",
    name: "FAQ",
  },
  {
    url: "/contacts",
    name: "Contact us",
  },
  {
    url: "/dmca-inquiry",
    name: "DMCA inquiry",
  },
  {
    url: "/donate-essay",
    name: "Donate a paper",
  },
  {
    url: "/search",
    name: "Search samples",
    lastmod: "2023-09-14T00:00:00.000Z",
  },
];

export const TOOL_PAGES = [
  {
    url: "/tools",
    name: "All tools",
  },
  {
    url: "/assignment-calendar",
    name: "Assignment calculator",
  },
  {
    url: "/conclusion-generator",
    name: "Conclusion generator",
  },
  {
    url: "/thesis-statement-generator",
    name: "Thesis statement generator",
  },
  {
    url: "/title-page-generator",
    name: "Title page generator",
  },
  {
    url: "/words-to-pages-converter",
    name: "Words to pages converter",
  },
  {
    url: "/words-to-pages-converter",
    name: "Words to pages converter",
  },
  {
    url: "/alphabetizer",
    name: "Alphabetizer",
    lastmod: "2023-11-21T00:00:01.000Z",
  },
  {
    url: "/assignment-calculator",
    name: "Assignment calculator",
    lastmod: "2023-11-21T00:00:01.000Z",
  },
  {
    url: "/title-case-converter",
    name: "Case converter",
    lastmod: "2023-11-21T00:00:01.000Z",
  },
  {
    url: "/grade-calculator",
    name: "Grade calculator",
    lastmod: "2023-11-21T00:00:01.000Z",
  },
  {
    url: "/grammar-checker",
    name: "Grammar checker",
    lastmod: "2023-11-21T00:00:01.000Z",
  },
  {
    url: "/paper-grader",
    name: "Paper grader",
    lastmod: "2023-11-21T00:00:01.000Z",
  },
  {
    url: "/readability-checker",
    name: "Readability checker",
    lastmod: "2023-11-21T00:00:01.000Z",
  },
  {
    url: "/spell-checker",
    name: "Spell checker",
    lastmod: "2023-11-21T00:00:01.000Z",
  },
  {
    url: "/title-page-generator",
    name: "Title page generator",
    lastmod: "2023-11-21T00:00:01.000Z",
  },
  {
    url: "/word-counter-tool",
    name: "Word counter",
    lastmod: "2023-11-21T00:00:01.000Z",
  },
  {
    url: "/words-to-minutes-converter",
    name: "Words to minutes converter",
    lastmod: "2023-11-21T00:00:01.000Z",
  },
  {
    url: "/words-to-pages-converter",
    name: "Words to pages converter",
    lastmod: "2023-11-21T00:00:01.000Z",
  },
];
